import type { Category } from "@/types";

export const NAV_LINKS = [{ label: "发现", to: "/discover" }] as const;

export const SCENE_CATEGORIES: Category[] = [
  {
    id: 0,
    slug: "personal",
    name: "工作空间",
    description: "默认个人的工作空间",
    sortOrder: 0,
    promptCount: 0,
  },
  {
    id: 4,
    slug: "ppt",
    name: "PPT",
    description: "汇报呈现。输入：内容生成的文案与结构。输出：可演示的幻灯片、汇报方案",
    sortOrder: 1,
    promptCount: 0,
  },
  {
    id: 6,
    slug: "office",
    name: "办公效率",
    description:
      "发现趋势与机会 / 定调与规划。输入：市场信号、用户反馈、竞品动态。输出：趋势结论、机会点、用户画像、内容方向",
    sortOrder: 2,
    promptCount: 0,
  },
  {
    id: 5,
    slug: "vibe-coding",
    name: "Vibe Coding",
    description: "技术落地。输入：内容生成的创意与逻辑。输出：可运行的代码、交互原型、工具",
    sortOrder: 3,
    promptCount: 0,
  },
  {
    id: 3,
    slug: "content-gen",
    name: "内容生成",
    description: "产出核心素材。输入：策略阶段的方向与目标。输出：文案初稿、创意素材、脚本大纲",
    sortOrder: 4,
    promptCount: 0,
  },
  {
    id: 1,
    slug: "insight",
    name: "洞察",
    description:
      "发现趋势与机会。输入：市场信号、用户反馈、竞品动态。输出：趋势结论、机会点、用户画像",
    sortOrder: 5,
    promptCount: 0,
  },
  {
    id: 2,
    slug: "strategy",
    name: "策略",
    description: "定调与规划。输入：洞察阶段的趋势结论。输出：内容方向、目标设定、资源分配",
    sortOrder: 6,
    promptCount: 0,
  },
  {
    id: 7,
    slug: "operations",
    name: "运营",
    description:
      "分发与增长。输入：PPT 汇报方案 / Vibe Coding 技术成果。输出：投放计划、增长实验、数据复盘",
    sortOrder: 7,
    promptCount: 0,
  },
];
